
export const partOrdersViewState = {
    namespaced: true,
    state: {
        tableOptions: {
            page: 1,
            itemsPerPage: 30,
            sortBy: ['modifyTime'],
            sortDesc: [true],
            mustSort: true,
            multiSort: false,
        },
    },
    mutations: {
        setTableOptions(state, tableOptions) {
            state.tableOptions = tableOptions;
        },
    },
    getters: {
        tableOptions: state => {
            return state.tableOptions;
        },
    },
};
